import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { File, FileText, FileSignature } from "lucide-react";
import { useIsMobile } from "@/hooks/use-mobile";
import BtnNavigateBack from "@/components/ui/btn_navigate_back";
import { useShowNavigateBack } from "@/hooks/useShowNavigateBack";
import { useTheme } from "@/context/ThemeContext";
import { useLanguage } from "@/context/LanguageContext";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import InvoiceManagement from "../economy/InvoiceManagement";
import ContractManagement from "../economy/ContractManagement";
import SellerContractManagement from "../economy/SellerContractManagement";
import { adminLabels, commonMenuLabels } from "@/i18n";

const AdminEconomy = () => {
  const isMobile = useIsMobile();
  const showPageBack = useShowNavigateBack();
  const { theme } = useTheme();
  const { language } = useLanguage();
  const menu = commonMenuLabels(language);
  const economy = adminLabels(language).economy;
  const isDark = theme === "dark";
  const [activeTab, setActiveTab] = useState("invoices");
  const [uploadOpen, setUploadOpen] = useState(false);

  const tabItems = [
    { value: "invoices", title: economy?.tabs?.invoices ?? "Fakturor", icon: File },
    { value: "contracts", title: economy?.tabs?.contracts ?? "Kontrakt", icon: FileText },
    { value: "seller-contracts", title: economy?.tabs?.sellerContracts ?? "Säljarkontrakt", icon: FileSignature },
  ];

  return (
    <div>
      {showPageBack && (
        <BtnNavigateBack label={menu?.dashboard ?? "Dashboard"} />
      )}
      <div className="px-4 md:px-0">
        <div className="flex justify-center mb-4">
          <h1 className="text-xl md:text-2xl font-bold tracking-tight">
            {economy?.title ?? "Ekonomi"}
          </h1>
        </div>
        <main>
          <Tabs
            value={activeTab}
            onValueChange={setActiveTab}
            className="w-full"
          >
            <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-2 my-6">
              <TabsList className="p-1 rounded-xl backdrop-blur">
                {tabItems.map((item) => (
                  <TabsTrigger
                    key={item.value}
                    value={item.value}
                    className={`flex items-center gap-2 rounded-lg py-2 ${
                      isDark
                        ? "data-[state=active]:bg-accent/70"
                        : "data-[state=active]:bg-accent"
                    }`}
                  >
                    <item.icon className="h-4 w-4" />
                    <span>{isMobile ? "" : item.title}</span>
                  </TabsTrigger>
                ))}
              </TabsList>
            </div>
            <TabsContent value="invoices">
              <InvoiceManagement />
            </TabsContent>
            <TabsContent value="contracts">
              <ContractManagement />
            </TabsContent>
            <TabsContent value="seller-contracts">
              <SellerContractManagement />
            </TabsContent>
          </Tabs>
        </main>
      </div>
    </div>
  );
};

export default AdminEconomy;
